var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.592,
    height: 20.087,
    viewBox: "0 0 18.592 20.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "share-svgrepo-com",
    d: "M23.259,12.507a3.783,3.783,0,0,0-2.916,1.372l-4.526-2.57a3.782,3.782,0,0,0,0-2.531l4.526-2.57a3.785,3.785,0,1,0-.656-1.153l-4.526,2.57a3.79,3.79,0,1,0,0,4.836l4.526,2.57a3.789,3.789,0,1,0,3.572-2.524Zm0-11.181A2.464,2.464,0,1,1,20.8,3.79,2.466,2.466,0,0,1,23.259,1.326ZM12.246,12.507a2.463,2.463,0,1,1,2.463-2.463A2.467,2.467,0,0,1,12.246,12.507Zm11.012,6.254A2.464,2.464,0,1,1,25.722,16.3,2.466,2.466,0,0,1,23.259,18.761Z",
    transform: "translate(-8.456)",
    fill: "#2D3040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.107072b1314336753716483592ca2c8a.svg";
export { ForwardRef as ReactComponent };